<template>
  <v-expansion-panels multiple class="d-flex flex-column">
    <div class="d-flex flex-grow-1 controls">
        <v-select :items="filters.states" v-model="state" item-text="label" item-value="value" :label="$t('alarms.filters.state.title')"></v-select>
    </div>
    <div class="d-flex flex-column flex-grow-1" v-if="alarms.length">

      <alarm-panel-item v-for="alarm in alarms" :key="alarm.id"
                        :alarm="alarm"
                        :selection="selection"
                        @selected="selection = $event"
                        @create-issue="createIssue([ $event ])"
                        @removed="remove([ $event ])"
                        @map="$emit('map', $event)">
      </alarm-panel-item>

      <div class="d-flex flex-column">
        <v-btn block text color="primary"
               v-if="selection.length"
               @click.stop="createIssue(selection)">
          {{ $t('alarms.create-issues') }}
        </v-btn>

        <v-btn block text color="error"
               v-if="state !== true"
               @click.stop="confirmDelete(() => remove(inactive))">
          {{ $t('alarms.controls.archive-inactive') }}
        </v-btn>
      </div>
    </div>

    <v-alert outlined type="success" icon="check_circle" class="d-flex flex-column flex-grow-1" v-if="!alarms.length">
      {{ $t('no-alarms') }}
    </v-alert>
  </v-expansion-panels>
</template>

<script>
import displayHelpers from '@/observer/helpers/display-helpers.es6'
import dialog from '@/observer/helpers/dialog-client.es6'
import AlarmPanelItem from '@/observer/alarms/alarm-panel-item'
import IssueDialog from '@/observer/issues/issue-dialog'

export default {
  name: 'alarms-panel',

  mixins: [ displayHelpers, dialog ],

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      filters: {
        states: [
          { value: null, label: this.$t('alarms.filters.state.all') },
          { value: true, label: this.$t('alarms.filters.state.active') },
          { value: false, label: this.$t('alarms.filters.state.inactive') }
        ]
      },
      selection: [],
      state: true,
    }
  },

  computed: {
    alarms () {
      // sort by time, descending
      return [...this.items]
        .filter(x => this.state === null || x.active === this.state)
        .sort((a, b) => {
          const aTime = new Date(a.detectedAt).getTime()
          const bTime = new Date(b.detectedAt).getTime()
          return Math.sign(bTime - aTime)
        })
    },

    inactive () {
      return this.items.filter(x => !x.active)
    }
  },

  methods: {
    async createIssue (alarms) {
      const issue = await this.$dialog.showAndWait(IssueDialog)

      if (!issue)
        return

      const data = {
        alarms: alarms.map(x => x.id),
        issue: issue
      }

      await this.$store.dispatch('updateItem', { modelName: 'issues', item: data })
      this.selection = []
      this.$emit('issue-created', null)
    },

    async remove (alarms) {
      await this.$store.dispatch('massDestroy', { modelName: 'alarms', items: alarms })
      this.$emit('removed', alarms)
    }
  },

  components: {
    AlarmPanelItem
  }
}
</script>

<style scoped lang="scss">

  @import '../../assets/variables';

  .controls {
    background-color: $color-light-gray;
    padding: 0 15px;
  }

</style>
